function openCart(o){
  document.getElementById('drawer').classList.toggle('on',o);
  document.getElementById('drawer').setAttribute('aria-hidden',String(!o));
  document.getElementById('overlay').classList.toggle('on',o);
  document.body.style.overflow = o?'hidden':'';
}

/* =========================================================
   View helpers
   ========================================================= */
function shotsFor(p){
  const base=p.colors[Math.min(sel.color,p.colors.length-1)][1];
  return [base, base+'_2', base+'_3'].filter(k=>IMG[k]);
}

const SWATCH = {
  'black':'#1D1D1F','space black':'#2B2B2E','black titanium':'#3A3A3C','midnight':'#1F2430','graphite':'#4A4B4F',
  'white':'#F2F2F4','silver':'#E3E4E8','white titanium':'#EDEDEA','starlight':'#EDE6DA','robot white':'#F4F4F6',
  'natural titanium':'#BFB8AD','desert titanium':'#C9AE92','cosmic orange':'#E07A3A',
  'blue':'#3E6A8A','blue titanium':'#3C4A62','deep blue':'#2C3E63','light blue':'#BCD4EA','ultramarine':'#6C7CE6',
  'teal':'#98CBC3','green':'#B6D2C1','pink':'#F1A9CF','violet':'#5E528F','deep purple':'#5B4A66','burgundy':'#6B2A36',
  'space grey':'#6A6B6E','red':'#B32135'
};
function dotsFor(p){
  if(p.colors.length<2) return '';
  return `<div class="dots2">${p.colors.slice(0,5).map(c=>`<i title="${c[0]}" style="background:${c[2]||SWATCH[c[0].toLowerCase()]||'#C7C7CC'}"></i>`).join('')}${p.colors.length>5?`<b>+${p.colors.length-5}</b>`:''}</div>`;
}

function tagFor(p){
  if(p.cat==='iphone'||p.cat==='android') return 'Unlocked';
  if(p.cat==='ipad') return p.specs.Connectivity||'Wi-Fi';
  return p.brand;
}
function pipFor(g){ return `<span class="pip ${GRADES[g].pip}"></span>`; }

function ico(name,size){
  const s=size||19;
  const paths={
    shield:'<path d="M12 3 4.5 6v6c0 4.4 3.1 8.1 7.5 9 4.4-.9 7.5-4.6 7.5-9V6z"/><path d="m8.8 12 2.2 2.2 4.2-4.4"/>',
    rotate:'<path d="M4 8h13l-3-3M20 16H7l3 3"/>',
    check:'<path d="m5 12.5 4.5 4.5L19 7.5"/>',
    truck:'<path d="M2.5 16V6.5h11V16M13.5 10h4l3 3.2V16M2.5 16h2M11.5 16h3.5"/><circle cx="6.5" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/>',
    lock:'<rect x="5" y="10" width="14" height="10" rx="2.5"/><path d="M8.5 10V7.5a3.5 3.5 0 0 1 7 0V10"/>',
    leaf:'<path d="M19 5c0 8-5 12-11 12H5c0-8 5-12 11-12z"/><path d="M5 19c3-6 7-8 10-9"/>',
    battery:'<rect x="3" y="7.5" width="15.5" height="9" rx="2.2"/><path d="M21 11v2M6.5 10.5v3M9.5 10.5v3M12.5 10.5v3"/>',
    scan:'<path d="M4 8V5.5A1.5 1.5 0 0 1 5.5 4H8M16 4h2.5A1.5 1.5 0 0 1 20 5.5V8M20 16v2.5a1.5 1.5 0 0 1-1.5 1.5H16M8 20H5.5A1.5 1.5 0 0 1 4 18.5V16M8 12h8"/>',
    parts:'<circle cx="12" cy="12" r="3"/><path d="M12 3v3M12 18v3M3 12h3M18 12h3M5.6 5.6l2.1 2.1M16.3 16.3l2.1 2.1M5.6 18.4l2.1-2.1M16.3 7.7l2.1-2.1"/>',
    erase:'<path d="M4 7h16M9 7V4.5h6V7M6.5 7l1 12.5h9l1-12.5"/>',
    phone:'<rect x="6.5" y="2.5" width="11" height="19" rx="2.6"/><path d="M10.5 18.5h3"/>',
    cable:'<path d="M9 3v4M15 3v4M7.5 7h9v3.5a4.5 4.5 0 0 1-9 0zM12 15v2.5a3.5 3.5 0 0 0 3.5 3.5H19"/>',
    box:'<path d="M3.5 7.5 12 3l8.5 4.5v9L12 21l-8.5-4.5z"/><path d="M3.5 7.5 12 12l8.5-4.5M12 12v9"/>',
    tag:'<path d="M3.5 12.2V4.5a1 1 0 0 1 1-1h7.7l8.3 8.3a1.4 1.4 0 0 1 0 2l-6.2 6.2a1.4 1.4 0 0 1-2 0z"/><circle cx="8" cy="8" r="1.4"/>',
    test:'<path d="M9 3h6M10 3v6l-5 9.5A1.7 1.7 0 0 0 6.5 21h11a1.7 1.7 0 0 0 1.5-2.5L14 9V3"/>'
  };
  return `<svg width="${s}" height="${s}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">${paths[name]||''}</svg>`;
}


const LAUNCH_ONLY=['ip15pm','ip15pro','ip15plus','ip15','ip14pm','ip14p','ip14plus','ip14','ip13pm','ip13pro','ip13','ip13mini','ip12','ip12mini','ip11','ipxr','s25p','s25','s24p','s24','s23p','s23','ipadair'];   // no longer sold new by Apple: compare with launch price
const newWord = p => LAUNCH_ONLY.includes(p.id) ? 'at launch' : 'new';
function cardHTML(p){
  const sold = p.stock===0, pct = Math.round((p.msrp-p.price)/p.msrp*100);
  return `<a class="card" href="#/p/${p.id}">
    <div class="thumb">${art(p.art,p.name,100)}</div>
    <h3>${p.name}</h3>
    <div class="meta">${[isCapacity(p.storage[0])?p.storage[0]:null, GRADES.excellent.label, tagFor(p)].filter(Boolean).join(' · ')}</div>
    ${dotsFor(p)}
    <div class="cond">${pipFor('excellent')} Deviceli Certified</div>
    <div class="price">${money(p.price)}<span class="was">${money(p.msrp)} ${newWord(p)}</span></div>
    ${sold?`<span class="soldout">Sold out</span>`:`<span class="save">Save ${pct}% vs ${LAUNCH_ONLY.includes(p.id)?'launch price':'new'}</span>`}
  </a>`;
}


function tradeBanner(withShell){
  const inner = `<div class="trade">
    <svg width="42" height="42" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 8h13l-3-3M20 16H7l3 3"/></svg>
    <div class="txt"><h3>Sell your old device</h3><p>A firm offer in about a minute. Free pickup in Ottawa–Gatineau, or a prepaid label anywhere in Canada.</p></div>
    <a class="btn" href="#/sell">See what it's worth</a>
  </div>`;
  return withShell===false ? inner : `<div class="shell">${inner}</div>`;
}

/* =========================================================
   Pages
   ========================================================= */
const COPY = {
'ip16pm':["The biggest iPhone Apple made before the 18 series, and the one that holds its value.",
  [["6.9-inch display","The largest Super Retina XDR at 120Hz."],
   ["A18 Pro chip","Apple Intelligence, and years of updates left."],
   ["48MP triple camera","5x telephoto and 4K120 video."]],
  "Device, USB-C cable and wall block."],
'ip16pro':["A Pro at a price the base model reached last year. Desert Titanium is the colour people ask for.",
  [["A18 Pro chip","Fast today, supported for years."],
   ["Titanium frame","Lighter than steel, tougher than glass."],
   ["Camera Control","A dedicated button for the camera."]],
  "Device, USB-C cable and wall block."],
'ip15pm':["The first Pro Max with 5x zoom and USB-C, now at half what it cost new.",
  [["5x telephoto","The longest zoom on any iPhone of its year."],
   ["A17 Pro chip","Handles every current app."],
   ["USB-C","One cable for the phone, the iPad and the Mac."]],
  "Device, USB-C cable and wall block."],
'ip15pro':["The cheapest way into titanium, USB-C and the Action button.",
  [["Titanium frame","Noticeably lighter in the hand."],
   ["A17 Pro chip","Console-grade games, smooth daily use."],
   ["Action button","Replace the mute switch with what you use."]],
  "Device, USB-C cable and wall block."],
'ip16plus':["The big screen and the long battery, without the Pro price.",
  [["6.7-inch display","Room for two apps, films and maps."],
   ["Longest battery","The best runtime of the 16 line."],
   ["A18 chip","Apple Intelligence ready."]],
  "Device, USB-C cable and wall block."],

'ip18pm':["The biggest screen and the longest battery Apple makes, one generation behind the counter price.",
  [["6.9-inch display","The largest Super Retina XDR, at 120Hz."],
   ["A20 Pro chip","Years of updates ahead of it."],
   ["48MP triple camera","5x telephoto, ProRAW, 4K120 video."]],
  "Device, USB-C cable and wall block."],
'ip18p':["The current Pro in the hand-friendly size, tested and warrantied like everything else we sell.",
  [["A20 Pro chip","Handles anything, including on-device AI."],
   ["Titanium frame","Light, and tougher than glass."],
   ["48MP triple camera","Telephoto, ProRAW, cinematic video."]],
  "Device, USB-C cable and wall block."],
's26u':["Samsung's flagship with the S Pen built in, at a price the new one will not reach for a long time.",
  [["200MP camera","Quad lenses, 5x optical zoom."],
   ["S Pen included","Notes, edits and precise selection."],
   ["6.9-inch AMOLED","120Hz, readable in full sun."]],
  "Device, S Pen, USB-C cable."],
"ip17p": ["The 17 Pro is the fastest iPhone we stock, and the one people keep the longest.", [["A19 Pro chip", "Handles anything you throw at it for years to come."], ["48MP triple camera", "5x telephoto, ProRAW, cinematic video."], ["Titanium frame", "Lighter than it looks, tougher than glass."]], "Device, USB-C cable and wall block."], "ip16": ["The iPhone 16 is the sweet spot: recent enough for every app, old enough to cost half of new.", [["A18 chip", "Apple Intelligence ready, fast for years."], ["48MP dual camera", "2x optical-quality zoom without a third lens."], ["Action button", "Remap it to the camera, the flashlight, whatever you use."]], "Device, USB-C cable and wall block."], "ip14p": ["Still the best value in a Pro: ProMotion, telephoto and Dynamic Island for the price of a mid-range new phone.", [["120Hz ProMotion", "Scrolling that makes a cheaper new phone feel slow."], ["48MP triple camera", "3x telephoto and the low-light sensor Pro models are known for."], ["Dynamic Island", "Live alerts and timers at the top of the screen."]], "Device, USB-C cable and wall block."], "ip13": ["Five years on, the iPhone 13 still gets iOS updates and still takes excellent photos. Our best seller.", [["A15 Bionic", "Runs every current app without a stutter."], ["All-day battery", "One of the longest-lasting iPhones of its generation."], ["Ceramic Shield", "Front glass tougher than most phones on sale today."]], "Device, Lightning cable and wall block."], "ip12": ["The cheapest way into a modern iPhone: 5G, OLED screen, Face ID, under C$350.", [["OLED display", "True blacks, not the LCD you get on new budget phones."], ["5G", "Full speed on every Canadian carrier."], ["A14 Bionic", "Still supported, still quick."]], "Device, Lightning cable and wall block."], "ipadair": ["An iPad Air with the M2 chip does everything the Pro does, for most people, at half the outlay.", [["Apple M2", "The same chip family as a MacBook Air."], ["11-inch Liquid Retina", "Laminated, anti-reflective, great for drawing."], ["Apple Pencil Pro ready", "Pairs and charges on the side magnetically."]], "Tablet, USB-C cable and wall block."], "mbp14": ["A 14-inch Pro is the machine that survives a whole career change. This one has years of work left.", [["M3 Pro, 18GB", "Video editing, Xcode, forty browser tabs. No fan noise."], ["Liquid Retina XDR", "1000 nits sustained, 120Hz, real HDR."], ["Ports that matter", "HDMI, SDXC, three Thunderbolt, MagSafe."]], "Laptop, MagSafe charger and USB-C power adapter."], "aw": ["Series 9 is the last generation before prices climbed. Wiped, reset, and fitted with a fresh band.", [["Always-On Retina", "Readable in direct sun, dims on your wrist."], ["ECG and blood oxygen", "The full health sensor set."], ["Double tap", "Answer a call with a pinch, one-handed."]], "Watch, new sport band and magnetic charging cable."], "ps5": ["A PS5 Slim with the disc drive, so you can buy games used too. Tested on a full game before it ships.", [["4K up to 120Hz", "Ray tracing and 3D audio on a modern TV."], ["1TB SSD", "Loading screens measured in seconds."], ["Disc drive", "Play and resell physical games."]], "Console, one DualSense controller, HDMI and power cables."], "ds5": ["A spare DualSense so the second player stops complaining.", [["Haptic feedback", "You feel surfaces and tension, not just rumble."], ["Adaptive triggers", "Resistance that changes with what you're doing."], ["PS5 and PC", "Works over Bluetooth on both."]], "Controller and USB-C cable."], "portal": ["Your PS5 on an 8-inch screen, anywhere in the house. The quiet answer to sharing the TV.", [["8-inch 1080p screen", "60fps streaming from your own PS5."], ["Full DualSense controls", "Haptics and adaptive triggers built in."], ["Up to 9 hours", "Long enough for any session."]], "Device and USB-C cable."], "xboxss": ["The cheapest way onto current-generation Xbox, and Game Pass makes the digital-only part a non-issue.", [["Up to 1440p 120Hz", "Smooth on a modern TV or monitor."], ["512GB SSD", "Near-instant resume between games."], ["Game Pass ready", "Hundreds of games on a monthly plan."]], "Console, one controller, HDMI and power cables."], "xboxpad": ["Works on Xbox, on Windows, and on your phone. The controller most PC players end up buying.", [["Textured grips", "Triggers and bumpers you don't slip off."], ["Share button", "Clip the last thirty seconds in one press."], ["Bluetooth", "Pairs with PC, iPhone and Android."]], "Controller only, batteries not included."], "ap3": ["Open, wear, done. AirPods with Spatial Audio for less than half of what new ones cost.", [["Spatial Audio", "Sound that stays put when you turn your head."], ["Sweat and water resistant", "Fine for the gym and the rain."], ["Up to 6 hours", "Thirty total with the case."]], "Earbuds, charging case and Lightning cable."]};

function addBizDays(d,n){ const x=new Date(d); while(n>0){ x.setDate(x.getDate()+1); const w=x.getDay(); if(w!==0&&w!==6) n--; } return x; }
function fmtDay(d){ return d.toLocaleDateString('en-CA',{weekday:'short',month:'short',day:'numeric'}); }
function delivery(){
  const now=new Date(), cutoff=new Date(now); cutoff.setHours(14,0,0,0);
  const w=now.getDay(), shipsToday = w!==0 && w!==6 && now<cutoff;
  const ship = shipsToday ? now : addBizDays(now,1);
  const a=addBizDays(ship,2), b=addBizDays(ship,4);
  let left='';
  if(shipsToday){ const m=Math.round((cutoff-now)/60000); left = m>=60 ? `${Math.floor(m/60)}h ${m%60}m` : `${m}m`; }
  return {range:`${fmtDay(a)} – ${fmtDay(b)}`, left, shipsToday};
}

const RANK = ['ip18pm','ip18p','ip17p','ip16pm','ip16pro','ip16plus','ip16','ip15pm','ip15pro','ip15plus','ip15','ip14pm','ip14p','ip14plus','ip14','ip13pm','ip13pro','ip13','ip13mini','ip12','ip12mini','ip11','ipxr',
              's26u','s25p','s25','s24p','s24','s23p','s23','ipadairm3','ipadmini7','ipad11','ipadair','mbp14','aw','ps5','portal','xboxss','ds5','xboxpad','ap3'];
P.sort((a,b)=>{
  const ca=CATS.findIndex(c=>c.id===a.cat), cb=CATS.findIndex(c=>c.id===b.cat);
  if(ca!==cb) return ca-cb;
  const ra=RANK.indexOf(a.id), rb=RANK.indexOf(b.id);
  return (ra<0?999:ra)-(rb<0?999:rb);
});

const ACCESSORIES = ['ds5','xboxpad','ap3'];

/* the entry price and the photo must describe the SAME device, or the banner misleads */
function cheapest(cat){
  const list = P.filter(p=>p.cat===cat && p.stock>0 && !ACCESSORIES.includes(p.id));
  return list.length ? list.reduce((a,b)=>b.price<a.price?b:a) : null;
}

const HERO_VIDEO = '';   // paste the URL of a short clip (MP4) here; the photo is used until then

const SLIDES = [
  {photo:'hero_lifestyle', title:()=>'Your trusted destination for refurbished tech.', sub:()=>'Fully tested and inspected. Backed by a 12-month warranty.',
   cta:'Shop certified', href:'#/shop', cta2:'Sell yours', href2:'#/sell', art:[['hero_lifestyle',0]]},
  {bg:'#E4EDFF', cat:'iphone', sub:()=>'Unlocked for every carrier. Battery at 80% or better, or we don’t sell it.', cta:'Shop iPhone', href:'#/shop/iphone'},
  {dark:true,    cat:'ipad',   sub:()=>'Same screen, same chip, same apps. One price tag down.', cta:'Shop iPad', href:'#/shop/ipad'},
  {bg:'#EAF0FF', cat:'android', sub:()=>'S Pen included, tested like everything else.', cta:'Shop Samsung', href:'#/shop/android'},
  {bg:'#DCE8FF', cat:'watch',  sub:()=>'Wiped, reset and fitted with a new band. Looks new on the wrist.', cta:'Shop watches', href:'#/shop/watch'},
  {bg:'#EAF0FF', cat:'mac',    sub:()=>'We publish the battery health before you buy. No surprises on day one.', cta:'Shop MacBook', href:'#/shop/mac'},
  {bg:'#E4EDFF', cat:'gaming', sub:()=>'Every console runs a full game before it ships. Controller included.', cta:'Shop gaming', href:'#/shop/gaming'}
];

function slideHTML(sl){
  if(sl.photo){
    return `<div class="slide photo">
      <div class="sphoto">${HERO_VIDEO
        ? `<video src="${HERO_VIDEO}" poster="${IMG[sl.photo]}" autoplay muted loop playsinline preload="metadata" aria-label="Devices being tested"></video>`
        : `<img src="${IMG[sl.photo]}" alt="Person smiling at a refurbished phone" loading="eager">`}</div>
      <div class="stxt">
        <h2>${sl.title()}</h2>
        <p>${sl.sub()}</p>
        <div class="slideacts pacts">
          <a class="hbtn solid" href="${sl.href}">${sl.cta}<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg></a>
          <a class="hlink" href="${sl.href2}">${sl.cta2}</a>
        </div>
        <p class="hproof">Professionally tested · 12-month warranty · 30-day returns</p>
      </div>
    </div>`;
  }
  const p = sl.cat ? cheapest(sl.cat) : null;
  const title = p ? `${p.name} from ${money(p.price)}` : (typeof sl.title==='function'?sl.title():sl.title);
  const sub   = typeof sl.sub==='function'?sl.sub():sl.sub;
  const shot  = p ? p.art : sl.art[0][0];
  const size  = p ? 150 : sl.art[0][1];
  const href  = sl.href;
  const cta   = sl.cta;
  return `<div class="slide ${sl.dark?'dark':''}" style="${sl.bg?`background:${sl.bg}`:''}">
    <div class="stxt">
      <h2>${title}</h2>
      <p>${sub}</p>
      <div class="slideacts">
        <a class="btn" href="${href}">${cta}</a>
        ${sl.cta2?`<a class="btn line" href="${sl.href2}">${sl.cta2}</a>`:''}
      </div>
    </div>
    <div class="sart">${art(shot,title,size)}</div>
  </div>`;
}

function pageHome(){
  const popular = ['ip18pm','s26u','ip16pro','ipadair'].map(id=>P.find(p=>p.id===id)).filter(Boolean);
  return `<div class="homex">
  <section class="hhero">${slideHTML(SLIDES[0])}</section>

  <div class="trio">
    <div>${ico('shield',24)}<b>Covered 12 months</b></div>
    <div>${ico('check',24)}<b>Deviceli Certified</b></div>
    <div>${ico('rotate',24)}<b>30 days to return</b></div>
    <div>${ico('truck',24)}<b>Free over ${money(FREE_SHIP)}</b></div>
  </div>

  <section class="catsec"><div class="shell">
    <div class="sechead"><h2>Popular categories</h2></div>
    <div class="popcats">
      ${CATS.map(c=>{ const pic = c.id==='iphone' ? 'p18pro_blue' : c.art;
        return `<a class="pc" href="#/shop/${c.id}"><span class="pcimg">${art(pic,c.label,90)}</span><span class="pcname">${c.label}</span></a>`; }).join('')}
    </div>
  </div></section>

  <section class="tint"><div class="shell">
    <div class="sechead"><h2>In stock now</h2><a class="seclink" href="#/shop${state.fav?'/'+state.fav:''}">View all</a></div>
    <div class="favtabs" role="tablist">
      <button class="${!state.fav?'on':''}" data-fav="">Top picks</button>
      ${CATS.filter(c=>P.some(x=>x.cat===c.id&&x.stock>0)).map(c=>`<button class="${state.fav===c.id?'on':''}" data-fav="${c.id}">${c.label}</button>`).join('')}
    </div>
    <div class="grid">${(state.fav ? P.filter(x=>x.cat===state.fav&&x.stock>0).slice(0,4) : popular).map(cardHTML).join('')}</div>
  </div></section>

  <section class="proof"><div class="shell">
    <div class="proofband">
      <div><b data-count="30">30</b><span>point inspection<br>on every device</span></div>
      <div><b data-count="80" data-suffix="%">80%</b><span>minimum<br>battery health</span></div>
      <div><b data-count="12">12</b><span>months of<br>warranty</span></div>
    </div>
    <p class="proofline">Tested and signed off by a technician. <a class="more" href="#/care/grading">How we certify</a></p>
  </div></section>

  <section class="tint"><div class="shell">
    <div class="arrive">
      <div class="arrhead">
        <p class="arrkick">The unboxing</p>
        <h2>Arrives ready to use.</h2>
        <p class="arrsub">Every order ships in a Deviceli box, cleaned, reset and checked one last time. No bubble mailer, no third-party seller.</p>
      </div>
      <div class="arrimg"><img src="${BOXSHOT}" alt="A Deviceli box next to a refurbished iPhone" loading="lazy" width="640" height="800"></div>
      <div class="arrtxt">
        <p class="arrlabel">In the box</p>
        <div class="arrbox">
          <div>${ico('phone',22)}<b>Your device</b><span>Cleaned and reset</span></div>
          <div>${ico('cable',22)}<b>Charging cable</b><span>The right one for it</span></div>
          <div>${ico('box',22)}<b>Deviceli box</b><span>Packed with care</span></div>
        </div>
        <ul class="arrtrust">
          <li>${ico('check',16)}Hand-tested</li>
          <li>${ico('truck',16)}Tracked delivery</li>
          <li>${ico('shield',16)}12-month warranty</li>
        </ul>
        <a class="more" href="#/shop">Shop certified</a>
      </div>
    </div>
  </div></section>

  <section class="doors"><div class="shell">
    <div class="sechead"><h2>Buy, sell, or both</h2></div>
    <div class="doorgrid">
      <a class="door" href="#/shop">
        <span class="dpic">${art('p16_black','',64)}</span>
        <span class="dtext">
          <span class="dnum">Buy</span>
          <b>A certified device</b>
        </span>
        <span class="dend"><em>From ${money(Math.min(...P.filter(x=>x.stock>0 && !ACCESSORIES.includes(x.id)).map(x=>x.price)))}</em><i aria-hidden="true">›</i></span>
      </a>
      <a class="door" href="#/sell">
        <span class="dpic">${art('p13_blue','',64)}</span>
        <span class="dtext">
          <span class="dnum">Sell</span>
          <b>Your old device</b>
          <span class="dline">Offer in a minute, free pickup in Ottawa–Gatineau</span>
        </span>
        <span class="dend"><em>Up to ${money(Math.max(...Object.values(TRADE).flatMap(o=>o.list.map(m=>m[1]))))}</em><i aria-hidden="true">›</i></span>
      </a>
      <a class="door dark" href="#/company">
        <span class="dpic">${art('mbp14_black','',64)}</span>
        <span class="dtext">
          <span class="dnum">Business</span>
          <b>Fleets, schools, resellers</b>
        </span>
        <span class="dend"><em>Wholesale</em><i aria-hidden="true">›</i></span>
      </a>
    </div>
  </div></section></div>`;
}

function seriesOf(p){ const m=p.name.match(/^(iPhone \d+|iPhone X[RS]?|Galaxy S\d+|Galaxy Z \w+)/); return m?m[1]:null; }
function pageShop(cat,sort,series){
  const q = state.query.trim().toLowerCase();
  let list = P.filter(p => (!cat||p.cat===cat) && (!q || (p.name+' '+p.brand).toLowerCase().includes(q)));
  const allSeries = [...new Set(list.map(seriesOf).filter(Boolean))];
  if(series) list = list.filter(p=>seriesOf(p)===series);
  if(sort==='low') list=[...list].sort((a,b)=>a.price-b.price);
  if(sort==='high') list=[...list].sort((a,b)=>b.price-a.price);
  if(sort==='save') list=[...list].sort((a,b)=>(b.msrp-b.price)-(a.msrp-a.price));
  const title = cat ? (CATS.find(c=>c.id===cat)||{}).label : 'All devices';
  return `<div class="shell">
    <div class="crumbs"><a href="#/">Home</a> / ${title}</div>
    <div class="sechead" style="margin-top:12px"><h2>${title}</h2></div>
    <div class="shoptop">
      <a class="chip ${!cat?'on':''}" href="#/shop">All</a>
      ${CATS.map(c=>`<a class="chip ${cat===c.id?'on':''}" href="#/shop/${c.id}">${c.label}</a>`).join('')}
    </div>
    ${cat && allSeries.length>1 ? `<div class="shoptop models">
      <a class="chip ${!series?'on':''}" href="#/shop/${cat}">All models</a>
      ${allSeries.map(x=>`<a class="chip ${series===x?'on':''}" href="#/shop/${cat}?series=${encodeURIComponent(x)}">${x.replace('Galaxy ','')}</a>`).join('')}
    </div>` : ''}
    <div class="toolbar">
      <span class="count">${list.length} device${list.length===1?'':'s'}${q?` for “${state.query}”`:''}</span>
      <select class="sort" id="sortSel" aria-label="Sort products">
        <option value="">Featured</option>
        <option value="low" ${sort==='low'?'selected':''}>Price: low to high</option>
        <option value="high" ${sort==='high'?'selected':''}>Price: high to low</option>
        <option value="save" ${sort==='save'?'selected':''}>Biggest savings</option>
      </select>
    </div>
    ${list.length?`<div class="grid">${list.map(cardHTML).join('')}</div>`
      :`<div class="empty"><p style="color:var(--ink);font-size:16px;font-weight:700">No devices match that search.</p><p>Try a model name like “iPhone 13”, or pick a category above.</p></div>`}
    <div style="height:26px"></div>
    ${tradeBanner(false)}
    <div style="height:20px"></div>
  </div>`;
}

const sel = {storage:0,color:0,grade:'excellent',shot:0};
function pageProduct(id){
  const p = P.find(x=>x.id===id);
  if(!p) return `<div class="shell"><div class="empty">That product no longer exists. <a class="seclink" href="#/shop">Back to shop</a></div></div>`;
  sel.storage=Math.min(sel.storage,p.storage.length-1);
  const base = storageBase(p,sel.storage), newp = storageNew(p,sel.storage);
  const price = gradePrice(base,sel.grade);
  sel.color=Math.min(sel.color,p.colors.length-1); sel.storage=Math.min(sel.storage,p.storage.length-1);
  const shots = shotsFor(p);
  const slides = shots.map(k=>({k,ci:sel.color})).concat(p.colors.map((c,ci)=>({k:c[1],ci})).filter(x=>x.ci!==sel.color));
  const boxShot = p.cat==='iphone';           // the packaging photo shows a phone, so only iPhones get it
  return `<div class="shell">
    <div class="crumbs pxcrumbs"><a href="#/">Home</a> / <a href="#/shop/${p.cat}">${(CATS.find(c=>c.id===p.cat)||{}).label}</a> / ${p.name}</div>
    <div class="pdp">
      <div class="gcol">
        <div class="gtrack" id="gtrack">
          ${slides.map(sl=>`<div class="gslide" data-ci="${sl.ci}">${art(sl.k,p.name+', '+p.colors[sl.ci][0],300)}</div>`).join('')}
        </div>
        ${slides.length>1?`<div class="gdots" id="gdots">${slides.map((_,i)=>`<i class="${i===0?'on':''}"></i>`).join('')}</div>`:''}
      </div>
      <div class="px">
        <p class="pxcert"><span class="pip"></span>Deviceli Certified</p>
        <h1>${p.name}</h1>
        <p class="pxsub">${['iphone','android'].includes(p.cat)?'Unlocked, works with every carrier':p.brand} · 12-month warranty</p>

        <div class="pxprice"><b>${money(price)}</b><s>${money(newp)} ${newWord(p)}</s><em>Save ${money(newp-price)}</em></div>
        <p class="pxstock ${p.stock===0?'out':''}">${p.stock===0?'Sold out. Tell us and we’ll hold the next one.':p.stock<5?`Only ${p.stock} left at this price`:'In stock, ready to ship'}</p>

        ${p.storage.length>1?`<div class="pxlab"><b>Storage</b></div>
        <div class="pxopts n${Math.min(p.storage.length,4)}">${p.storage.map((s,i)=>`<button class="${i===sel.storage?'on':''}" data-storage="${i}"><b>${s}</b><small>${money(gradePrice(storageBase(p,i),sel.grade))}</small></button>`).join('')}</div>`:''}

        <div class="pxlab"><b>Colour</b><span id="colName">${p.colors[sel.color][0]}</span></div>
        <div class="pxsw" ${p.colors.length<2?'hidden':''}>${p.colors.map((c,i)=>`<button class="swatch ${i===sel.color?'on':''}" data-color="${i}" aria-label="${c[0]}">${art(c[1],c[0],36)}</button>`).join('')}</div>

        <div class="pxlab"><b>Condition</b><a class="pxhow" href="#/care/grading">How grading works</a></div>
        <div class="pxopts n3 pxgr">${Object.entries(GRADES).map(([k,g])=>`<button class="${sel.grade===k?'on':''}" data-grade="${k}"><b><span class="pip ${g.pip}"></span>${g.label}</b><small>${money(gradePrice(base,k))}</small></button>`).join('')}</div>
        <p class="pxnote">${GRADES[sel.grade].note} Every grade is 100% functional, with a battery at 80% or better.</p>

        <button class="btn wide pxbuy" id="addBtn" ${p.stock===0?'disabled':''}>${p.stock===0?'Out of stock':'Add to cart'}</button>
        ${p.stock>0?(()=>{ const d=delivery(); return `<p class="pxeta">${ico('truck',17)}<span>Arrives <b>${d.range}</b>. ${price>=FREE_SHIP?'Free tracked delivery.':'Tracked delivery, free over '+money(FREE_SHIP)+'.'}</span></p>`; })():''}

        <div class="pxperks">
          <div>${ico('shield',20)}<b>12-month warranty</b><span>Parts and labour</span></div>
          <div>${ico('rotate',20)}<b>30-day returns</b><span>Free, full refund</span></div>
          ${['ps5','xboxss','xboxpad'].includes(p.id)?`<div>${ico('check',20)}<b>30-point check</b><span>Professionally tested</span></div>`:`<div>${ico('battery',20)}<b>Battery 80%+</b><span>Measured on every device</span></div>`}
          ${['iphone','android'].includes(p.cat)?`<div>${ico('lock',20)}<b>Unlocked</b><span>Any Canadian carrier</span></div>`:`<div>${ico('truck',20)}<b>Tracked delivery</b><span>${price>=FREE_SHIP?'Free, across Canada':'Free over '+money(FREE_SHIP)}</span></div>`}
        </div>

        <div class="pxacc">
          ${p.blurb||p.high?`<details open><summary>About this ${p.name}</summary><div>
            ${p.blurb?`<p>${p.blurb}</p>`:''}
            ${p.high?`<ul class="pxhigh">${p.high.map(h=>`<li><b>${h[0]}</b><span>${h[1]}</span></li>`).join('')}</ul>`:''}
          </div></details>`:''}
          <details><summary>In the box</summary><div>
            ${boxShot?`<div class="boxscene"><img src="${BOXSHOT}" alt="What ships with the ${p.name}" loading="lazy"></div>`:''}
            <p>${p.box?p.box+'. ':''}Cleaned, wiped and reset before it ships.</p>
          </div></details>
          <details><summary>Specifications</summary><div>
            <dl class="pxspecs">${Object.entries(p.specs).map(([k,v])=>`<div><dt>${k}</dt><dd>${v}</dd></div>`).join('')}<div><dt>Warranty</dt><dd>12 months</dd></div><div><dt>Returns</dt><dd>30 days</dd></div></dl>
          </div></details>
          <details><summary>Delivery and returns</summary><div>
            <p>Orders placed before 2pm on a business day ship the same day, tracked, anywhere in Canada. Delivery is free over ${money(FREE_SHIP)}.</p>
            <p>Changed your mind? Send it back within 30 days for a full refund. If it arrives defective or not as described, the return is on us. <a class="seclink" href="#/care/returns">Returns</a></p>
          </div></details>
        </div>
      </div>
    </div>
    ${p.stock>0?`<div class="buybar" id="buybar">
      <div><span>${p.name} · ${[isCapacity(p.storage[sel.storage])?p.storage[sel.storage]:null,GRADES[sel.grade].label].filter(Boolean).join(' · ')}</span><b>${money(price)}</b></div>
      <button class="btn" data-buybar>Add to cart</button>
    </div>`:''}
    <section><div class="sechead"><h2>You might also like</h2></div>
      <div class="grid">${P.filter(x=>x.cat===p.cat&&x.id!==p.id).slice(0,4).map(cardHTML).join('')}</div>
    </section>
  </div>`;
}

/* ---- sell flow ---- */
const sell = {step:0,cat:null,model:null,find:'',contract:null,carrier:null,storage:null,batt:null,grade:null,email:'',phone:'',name:'',contact:'',handoff:'pickup',slot:null,conn:null,ctrl:null,pay:'etransfer',basket:[],emailErr:'',help:false};

const STEP_LABELS = ['Category','Item','Details','Condition','Your offer','Next steps'];

const CARRIERS = [
  ['Telus',false],['Rogers',false],['Fido',false],['Koodo',false],
  ['Bell',true],['Freedom Mobile',true],['Virgin Plus',true]
];
const blockedCarrier = () => (CARRIERS.find(c=>c[0]===sell.carrier)||[,false])[1];

const HAS_BATTERY = ['iphone','android','ipad','mac','watch'];

const GRADES_SELL = [
  {k:'flawless', t:'Flawless', m:1,    d:'Looks like new. No visible scratches, no cracks, no dents.'},
  {k:'good',     t:'Good',     m:.92,  d:'Light wear you cannot see from arm’s length. No cracks, no dents, screen perfect.'},
  {k:'used',     t:'Used',     m:.78,  d:'Visible scratches or dents, but the glass is intact and everything works.'},
  {k:'broken',   t:'Broken',   m:.42,  d:'Cracked glass, a fault, or it will not turn on. We still buy it.'}
];


/* =========================================================
   Buyback: the real configurations of each model.
   The price in TRADE is the value at the model's smallest configuration;
   each step up adds value. A model with one configuration skips the question.
   ========================================================= */
const CAP_STEP = [1, 1.07, 1.15, 1.22, 1.30];
const MODEL_CAPS = {
  /* iPhone */
  'iPhone 18 Pro Max':['256GB','512GB','1TB','2TB'], 'iPhone 18 Pro':['256GB','512GB','1TB'],
  'iPhone 17 Pro Max':['256GB','512GB','1TB','2TB'], 'iPhone 17 Pro':['256GB','512GB','1TB'], 'iPhone 17':['256GB','512GB'],
  'iPhone 16 Pro Max':['256GB','512GB','1TB'], 'iPhone 16 Pro':['128GB','256GB','512GB','1TB'],
  'iPhone 16 Plus':['128GB','256GB','512GB'], 'iPhone 16':['128GB','256GB','512GB'],
  'iPhone 15 Pro Max':['256GB','512GB','1TB'], 'iPhone 15 Pro':['128GB','256GB','512GB','1TB'], 'iPhone 15':['128GB','256GB','512GB'],
  'iPhone 14 Pro':['128GB','256GB','512GB','1TB'], 'iPhone 14':['128GB','256GB','512GB'],
  'iPhone 13':['128GB','256GB','512GB'], 'iPhone 12':['64GB','128GB','256GB'], 'iPhone 11':['64GB','128GB','256GB'],
  'iPhone SE (3rd Gen)':['64GB','128GB','256GB'],
  /* Android */
  'Galaxy S26 Ultra':['256GB','512GB','1TB'], 'Galaxy S25 Ultra':['256GB','512GB','1TB'], 'Galaxy S24 Ultra':['256GB','512GB','1TB'],
  'Galaxy S24':['128GB','256GB'], 'Galaxy S23':['128GB','256GB'], 'Galaxy Z Flip6':['256GB','512GB'], 'Galaxy Z Fold6':['256GB','512GB','1TB'],
  'Galaxy A55':['128GB','256GB'], 'Pixel 9 Pro':['128GB','256GB','512GB','1TB'], 'Pixel 9':['128GB','256GB'], 'Pixel 8':['128GB','256GB'],
  'OnePlus 12':['256GB','512GB'],
  /* iPad */
  'iPad Pro 13" (M4)':['256GB','512GB','1TB','2TB'], 'iPad Pro 11" (M4)':['256GB','512GB','1TB','2TB'],
  'iPad Air (M2)':['128GB','256GB','512GB','1TB'], 'iPad Air (5th Gen)':['64GB','256GB'], 'iPad (10th Gen)':['64GB','256GB'],
  'iPad (9th Gen)':['64GB','256GB'], 'iPad mini (6th Gen)':['64GB','256GB'],
  /* Mac: memory / storage */
  'MacBook Pro 16" M3 Max':['36GB / 1TB','48GB / 1TB','64GB / 2TB','128GB / 2TB'],
  'MacBook Pro 14" M3':['8GB / 512GB','8GB / 1TB','16GB / 1TB','24GB / 1TB'],
  'MacBook Air 15" M3':['8GB / 256GB','8GB / 512GB','16GB / 512GB','24GB / 1TB'],
  'MacBook Air 13" M3':['8GB / 256GB','8GB / 512GB','16GB / 512GB','24GB / 1TB'],
  'MacBook Air M2':['8GB / 256GB','8GB / 512GB','16GB / 512GB','24GB / 1TB'],
  'MacBook Air M1':['8GB / 256GB','8GB / 512GB','16GB / 512GB','16GB / 1TB'],
  'Mac mini (M2)':['8GB / 256GB','8GB / 512GB','16GB / 512GB','24GB / 1TB'],
  'iMac 24" (M1)':['8GB / 256GB','8GB / 512GB','16GB / 512GB','16GB / 1TB'],
  /* Watch: case size and connectivity */
  'Apple Watch Ultra 2':[['49mm, GPS + Cellular',1]],
  'Apple Watch Series 10':[['42mm, GPS',1],['46mm, GPS',1.05],['42mm, GPS + Cellular',1.1],['46mm, GPS + Cellular',1.15]],
  'Apple Watch Series 9':[['41mm, GPS',1],['45mm, GPS',1.05],['41mm, GPS + Cellular',1.1],['45mm, GPS + Cellular',1.15]],
  'Apple Watch Series 8':[['41mm, GPS',1],['45mm, GPS',1.05],['41mm, GPS + Cellular',1.1],['45mm, GPS + Cellular',1.15]],
  'Apple Watch SE (2nd Gen)':[['40mm, GPS',1],['44mm, GPS',1.05],['40mm, GPS + Cellular',1.1],['44mm, GPS + Cellular',1.15]],
  'Galaxy Watch7':[['40mm, Bluetooth',1],['44mm, Bluetooth',1.05],['40mm, LTE',1.1],['44mm, LTE',1.15]],
  'Pixel Watch 3':[['41mm, Wi-Fi',1],['45mm, Wi-Fi',1.06],['41mm, LTE',1.1],['45mm, LTE',1.16]],
  /* Gaming: editions that change the value */
  'PlayStation 5 Pro':[['2TB',1]],
  'PlayStation 5 Slim':[['Disc edition, 1TB',1],['Digital edition, 1TB',.88]],
  'Xbox Series X':[['1TB, disc',1],['2TB Galaxy Black',1.12],['1TB Digital, white',.9]],
  'Xbox Series S':[['512GB',1],['1TB',1.1]],
  'Nintendo Switch 2':[['256GB',1]], 'Nintendo Switch OLED':[['64GB',1]]
};
const CAP_TITLE = {iphone:'Storage', android:'Storage', ipad:'Storage', mac:'Memory and storage', watch:'Case size and connectivity', gaming:'Edition', audio:'Version'};
function capsFor(model){
  const raw = MODEL_CAPS[model];
  if(!raw) return [['Standard',1]];
  return raw.map((c,i)=>Array.isArray(c)?c:[c, CAP_STEP[Math.min(i,CAP_STEP.length-1)]]);
}
function upTo(model, base){ const c=capsFor(model); return Math.round(base*Math.max(...c.map(x=>x[1]))/5)*5; }
const ART_ALIAS = {'Xbox controller':'Xbox Wireless Controller'};
function modelArt(model, cat){
  const name=(ART_ALIAS[model]||model).toLowerCase();
  const p=P.find(x=>x.name.toLowerCase()===name);
  return p ? p.art : (TRADE[cat]||{}).art;
}

function capList(){ return capsFor(sell.model); }
function modelBase(){ const m=((TRADE[sell.cat]||{}).list||[]).find(x=>x[0]===sell.model); return m?m[1]:0; }
const BATT = [
  {k:'90', t:'90% or more',  m:1},
  {k:'85', t:'85 to 89%',    m:.97},
  {k:'80', t:'80 to 84%',    m:.93},
  {k:'79', t:'Below 80%',    m:.87},
  {k:'unk',t:"I don't know", m:.93}
];
function battInfo(){ return BATT.find(x=>x.k===sell.batt)||null; }
